var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBurgerArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 14,
    viewBox: "0 0 21 14",
    width: 21,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#292929"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m17.05 12h-16.1c-.52467 0-.95.4253-.95.95v.1c0 .5247.42533.95.95.95h16.1c.5247 0 .95-.4253.95-.95v-.1c0-.5247-.4253-.95-.95-.95z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.4194 6h-9.838844c-.320632 0-.580556.42533-.580556.95v.1c0 .52467.259924.95.580556.95h9.838844c.3207 0 .5806-.42533.5806-.95v-.1c0-.52467-.2599-.95-.5806-.95z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.05 0h-16.1c-.52467 0-.95.425329-.95.95v.1c0 .52467.42533.95.95.95h16.1c.5247 0 .95-.42533.95-.95v-.1c0-.524671-.4253-.95-.95-.95z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.5559 5.95-4.1401.05409 1.3-1.29c.1883-.1883.2941-.4437.2941-.71s-.1058-.52169-.2941-.71c-.1883-.1883-.4437-.29409-.71-.29409s-.5217.10579-.71.29409l-3 3c-.0937.09296-.1681.20357-.2189.32542-.0508.12186-.0769.25257-.0769.38458s.0261.26272.0769.38458.1252.23246.2189.32542l3 3.00001c.093.0937.2036.1681.3254.2189.1219.0508.2526.0769.3846.0769s.2627-.0261.3846-.0769c.1218-.0508.2324-.1252.3254-.2189.0937-.093.1681-.2036.2189-.3254.0508-.1219.0769-.2526.0769-.3846 0-.13202-.0261-.26273-.0769-.38459-.0508-.12185-.1252-.23246-.2189-.32542l-1.3-1.29 4.1401-.05409c.248-.01212.4827-.1161.6583-.2917s.2795-.41026.2917-.6583v-.05c.0003-.25678-.0982-.50384-.275-.69-.1769-.18616-.4186-.29716-.675-.31z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgerArrow);
export default __webpack_public_path__ + "static/media/BurgerArrow.40fe1737.svg";
export { ForwardRef as ReactComponent };